export const ASSETS = {
  logoLeapifyes: "https://res.cloudinary.com/dnjsjo6yx/image/upload/f_auto,q_auto/v1772800285/logo_de_leapifyes_circular_elr6v1.jpg",
  logoMando:     "https://res.cloudinary.com/dnjsjo6yx/image/upload/f_auto,q_auto/v1770925218/MANDO_by_Leapifyes_tajoao.png",
  logoTrebol:    "https://res.cloudinary.com/dnjsjo6yx/image/upload/f_auto,q_auto/v1772801223/IMG_5059_wgwi2s.jpg",
  logoIA:        "https://res.cloudinary.com/dnjsjo6yx/image/upload/f_auto,q_auto/v1772800285/logo_de_leapifyes_circular_elr6v1.jpg",
  fotoRicardo:   "https://res.cloudinary.com/dnjsjo6yx/image/upload/f_auto,q_auto/v1772801910/Ricardo_Serrano_Img_Ejecutiva._ue8eud.jpg"
};
